<template lang="html">
  <section
    class="popup-vehiculo-electrico waypoints"
    data="fadeInRight"
    v-if="popup"
  >
    <div class="btn-close" @click="closeMoreInfo">
      <img src="/static/img/icon-close-dark.svg" alt="Cerrar" />
    </div>
    <img class="logo"
      src="/static/img/vehiculo-electrico/electric-vehicle-line-logo.svg"
      alt="logo electric vehicle line ajusa"
    />

    <img class="coche"
      src="/static/img/vehiculo-electrico/tesla.png"
      alt="vehiculo eléctrico"
    />

    <button class="btn btn-green -green" @click="gotoPage">
      {{ $t("popupCocheElectrico.btnText") }}
    </button>
  </section>
</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'popup-vehiculo-electrico',
    props: ['data'],
    mounted() {

    },
    data() {
        return {

        }
    },
    methods: {
        ...mapActions({
          changePopup: 'changePopup'
        }),
         closeMoreInfo: function () {
          this.changePopup(false)
        },
         gotoPage: function () {
          this.changePopup(false)
          this.$router.push({ name: "vehiculo_electrico" });
        },

    },
    computed: {
        ...mapGetters({
            popup:'getPopup'
        })
    }
}
</script>
<style>
.popup-vehiculo-electrico {
  position: fixed;
  bottom: 5%;
  right: 2%;
  z-index: 999;
  background: rgba(255, 255, 255, .8705882352941177);
  padding: 30px;
  padding-left: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: rgba(6, 6, 130, 1);
}

.popup-vehiculo-electrico .coche {
  position: absolute;
  bottom: -12%;
  left: -20%;
}

.btn-close {
  position: absolute;
  right: 18px;
  top: 18px;
  display: flex;
  justify-content: flex-end;
  max-width: 40px;
  cursor: pointer;
}
.popup-vehiculo-electrico .title {
  font-size: 16px;
  color: white;
  margin: 20px 0;
  line-height: 1.6em;
  text-align: center;
}
@media screen and (max-width: 600px) {
  .popup-vehiculo-electrico {
    max-width: 100%;
    left: 0;
    right: 0;
    padding: 20px;
    bottom: 0;
    border-radius: 0;
  }
  .popup-vehiculo-electrico .logo {
    max-width: 250px;
  }
  .popup-vehiculo-electrico .coche {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/popup-vehiculo-electrico.vue